export default "__VITE_ASSET__91c77b4e__"